import { pathMatches } from "../util/pathMatches";
var MaxLocationChangeEventDetail = /** @class */ (function () {
    function MaxLocationChangeEventDetail(targetUrl) {
        this.targetUrl = targetUrl;
    }
    MaxLocationChangeEventDetail.prototype.targetPathMatches = function (path) {
        var _a;
        return this.targetUrl ? pathMatches((_a = this.targetUrl) === null || _a === void 0 ? void 0 : _a.pathname, path) : false;
    };
    return MaxLocationChangeEventDetail;
}());
export { MaxLocationChangeEventDetail };
